'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _glamor = require('glamor');

var _reactRedux = require('react-redux');

var _reduxForm = require('redux-form');

var _zendesk = require('../../redux/modules/zendesk');

var _IndieProgramFormValidation = require('../../utils/IndieProgramFormValidation');

var _IndieProgramFormValidation2 = _interopRequireDefault(_IndieProgramFormValidation);

var _emailValidator = require('email-validator');

var _IndieProgramPopup = require('@quixeltools/quixel-ui-library/dist/components/megascans/popups/IndieProgramPopup');

var _IndieProgramPopup2 = _interopRequireDefault(_IndieProgramPopup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function validate(values) {
  // console.log('values',values);
  var errors = {};
  var isUrlValid = function isUrlValid(userInput) {
    if (userInput != null && userInput != "") {
      var res = userInput.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g);
      if (res == null) return false;else return true;
    } else return true;
  };
  var isArtworkUrlValid = function isArtworkUrlValid(userInput) {

    var res = userInput && userInput.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g);
    if (res == null || typeof res === 'undefined') return false;else return true;
  };
  // errors.checkBoxPc = values.checkBoxPc!==true || values.checkBoxSmartPhone !==true || values.checkBoxPlayStation !==true || values.checkBoxPlayStation !==true
  //                     values.checkBoxXbox !==true || values.checkBoxNitendo || values.checkBoxMac !==true  || values.checkBoxVr !==true || values.checkBoxOther !==true
  //
  //
  errors.checkBoxSmartPhone = values.checkBoxPc !== true && values.checkBoxSmartPhone !== true && values.checkBoxPlayStation !== true && values.checkBoxXbox !== true && values.checkBoxNitendo !== true && values.checkBoxMac !== true && values.checkBoxVr !== true && values.checkBoxOther !== true;

  errors.checkBoxPc = values.checkBoxPc !== true && values.checkBoxSmartPhone !== true && values.checkBoxPlayStation !== true && values.checkBoxXbox !== true && values.checkBoxNitendo !== true && values.checkBoxMac !== true && values.checkBoxVr !== true && values.checkBoxOther !== true;

  errors.checkBoxPlayStation = values.checkBoxPc !== true && values.checkBoxSmartPhone !== true && values.checkBoxPlayStation !== true && values.checkBoxXbox !== true && values.checkBoxNitendo !== true && values.checkBoxMac !== true && values.checkBoxVr !== true && values.checkBoxOther !== true;

  errors.checkBoxXbox = values.checkBoxPc !== true && values.checkBoxSmartPhone !== true && values.checkBoxPlayStation !== true && values.checkBoxXbox !== true && values.checkBoxNitendo !== true && values.checkBoxMac !== true && values.checkBoxVr !== true && values.checkBoxOther !== true;

  errors.checkBoxNitendo = values.checkBoxPc !== true && values.checkBoxSmartPhone !== true && values.checkBoxPlayStation !== true && values.checkBoxXbox !== true && values.checkBoxNitendo !== true && values.checkBoxMac !== true && values.checkBoxVr !== true && values.checkBoxOther !== true;

  errors.checkBoxMac = values.checkBoxPc !== true && values.checkBoxSmartPhone !== true && values.checkBoxPlayStation !== true && values.checkBoxXbox !== true && values.checkBoxNitendo !== true && values.checkBoxMac !== true && values.checkBoxVr !== true && values.checkBoxOther !== true;

  errors.checkBoxVr = values.checkBoxPc !== true && values.checkBoxSmartPhone !== true && values.checkBoxPlayStation !== true && values.checkBoxXbox !== true && values.checkBoxNitendo !== true && values.checkBoxMac !== true && values.checkBoxVr !== true && values.checkBoxOther !== true;

  errors.checkBoxOther = values.checkBoxPc !== true && values.checkBoxSmartPhone !== true && values.checkBoxPlayStation !== true && values.checkBoxXbox !== true && values.checkBoxNitendo !== true && values.checkBoxMac !== true && values.checkBoxVr !== true && values.checkBoxOther !== true;

  //errors.name = values.name == null || values.name == ""


  //errors.email = values.email == ""
  // errors.name = values.name == ""
  //errors.studio = values.studio ==""
  errors.teamSize = values.teamSize === null || values.teamSize === '' ? "Team Size is required" : null;
  errors.studio = values.studio === null || values.studio === '' ? "Studio Name is required" : null;
  errors.releaseDate = values.releaseDate === null || values.releaseDate === '' ? "Release Date is required" : null;
  if (values.select === null || values.select === '') errors.select = "Engine is required";
  errors.name = values.name === null || values.name === '' ? "Name is required" : null;
  errors.email = (0, _emailValidator.validate)(values.email) !== true ? "Email is invalid" : null;
  errors.SocialPortfolioUrl = values.SocialPortfolioUrl === null || values.SocialPortfolioUrl === '' || typeof values.SocialPortfolioUrl === 'undefined' ? "Social / Portfolio url is required." : null;

  if (!isUrlValid(values.url)) {
    errors.url = "Insert a valid URL.";
  }
  if (!isUrlValid(values.SocialPortfolioUrl)) {
    errors.SocialPortfolioUrl = "Insert a valid URL.";
  }
  if (!isUrlValid(values.publishGameUrl)) {
    errors.publishGameUrl = "Insert a valid URL.";
  }
  if (!isArtworkUrlValid(values.artworkUrl)) {
    errors.artworkUrl = "Insert a valid URL.";
  }

  errors.title = values.title === null || values.title === '' ? "Title is required." : null;
  errors.comments = values.comments === null || values.comments === '' ? "Message is required." : null;
  return errors;
}

var IndieProgramContainer = (_dec = (0, _reduxForm.reduxForm)({
  form: 'indie',
  fields: ['name', 'email', 'studio', 'title', 'url', 'artworkUrl', 'subject', 'comments', 'checkBoxPc', 'checkBoxSmartPhone', 'checkBoxPlayStation', 'checkBoxXbox', 'checkBoxNitendo', 'checkBoxMac', 'checkBoxVr', 'checkBoxOther', 'select', 'teamSize', 'releaseDate', 'checkBoxFunding', 'checkBoxPublisher', 'SocialPortfolioUrl', 'publishGameUrl'],
  validate: validate
}), _dec2 = (0, _reactRedux.connect)(null, { createTicket: _zendesk.createTicket }), _dec(_class = _dec2(_class = function (_React$Component) {
  (0, _inherits3.default)(IndieProgramContainer, _React$Component);

  function IndieProgramContainer(props) {
    (0, _classCallCheck3.default)(this, IndieProgramContainer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (IndieProgramContainer.__proto__ || (0, _getPrototypeOf2.default)(IndieProgramContainer)).call(this, props));

    _this.state = {
      message: null,
      error: null
    };

    _this.onSubmitClick = _this.onSubmitClick.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(IndieProgramContainer, [{
    key: 'Platform',
    value: function Platform(value) {
      var _values = values,
          checkBoxPc = _values.checkBoxPc,
          checkBoxSmartPhone = _values.checkBoxSmartPhone,
          checkBoxPlayStation = _values.checkBoxPlayStation,
          checkBoxXbox = _values.checkBoxXbox,
          checkBoxNitendo = _values.checkBoxNitendo,
          checkBoxMac = _values.checkBoxMac,
          checkBoxVr = _values.checkBoxVr,
          checkBoxOther = _values.checkBoxOther;
    }
  }, {
    key: 'complieMessage',
    value: function complieMessage(values) {
      var array = [];
      var name = values.name,
          email = values.email,
          url = values.url,
          artworkUrl = values.artworkUrl,
          comments = values.comments,
          studio = values.studio,
          title = values.title,
          select = values.select,
          teamSize = values.teamSize,
          releaseDate = values.releaseDate,
          checkBoxPc = values.checkBoxPc,
          checkBoxSmartPhone = values.checkBoxSmartPhone,
          checkBoxPlayStation = values.checkBoxPlayStation,
          checkBoxXbox = values.checkBoxXbox,
          checkBoxNitendo = values.checkBoxNitendo,
          checkBoxMac = values.checkBoxMac,
          checkBoxVr = values.checkBoxVr,
          checkBoxOther = values.checkBoxOther,
          checkBoxPublisher = values.checkBoxPublisher,
          checkBoxFunding = values.checkBoxFunding,
          publishGameUrl = values.publishGameUrl,
          SocialPortfolioUrl = values.SocialPortfolioUrl;

      if (checkBoxPc) {
        array.push('PC');
      }
      if (checkBoxSmartPhone) {
        array.push(' Smartphones/Tablets');
      }if (checkBoxPlayStation) {
        array.push(' PlayStation');
      }if (checkBoxXbox) {
        array.push(' Xbox');
      }if (checkBoxNitendo) {
        array.push(' Nintendo Switch');
      }if (checkBoxMac) {
        array.push(' Mac');
      }if (checkBoxVr) {
        array.push(' VR/AR Headsets');
      }if (checkBoxOther) {
        array.push(' Other');
      }

      return 'Name: ' + name + '\n       Email: ' + email + '\n       Studio name: ' + studio + '  \n       Working title of project: ' + title + ' \n       URL: ' + url + '\n       Megascans artwork URL: ' + artworkUrl + ' \n       Published games: ' + (publishGameUrl || '') + '\n       Social / Portfolio: ' + SocialPortfolioUrl + '\n       Platform: ' + array + '\n       Engine: ' + select + ' \n       Team size: ' + teamSize + ' \n       Release date: ' + releaseDate + ' \n       I have funding: ' + (checkBoxFunding ? 'YES' : 'NO') + '\n       I have a publisher: ' + (checkBoxPublisher ? 'YES' : 'NO') + '\n       Message: ' + comments + '  \n      ';
    }
    // Name(values){
    //   const {  name   } = values;
    //   return(
    //
    //     `Name: ${name}
    //     `
    //   )
    // }
    // //
    // Email(values){
    //   const {  email   } = values;
    //   return(
    //
    //     `Email: ${email}
    //     `
    //   )
    // }

  }, {
    key: 'onSubmitClick',
    value: function onSubmitClick(values) {
      var _this2 = this;

      this.setState({
        message: null,
        error: null
      });
      var name = values.name,
          email = values.email,
          subject = values.subject;

      // var name = this.Name(values);
      // var email = this.Email(values);

      var message = this.complieMessage(values);
      // var name = this.Name(values);
      //console.log(message);
      var tag = this.props.tag || 'regular';

      var custom_fields = [{
        id: '360000990877',
        value: 'Indie_Program'
      }];

      return this.props.createTicket({ name: name, email: email, comment: message, tag: tag, subject: subject, custom_fields: custom_fields }).then(function () {
        _this2.setState({
          message: 'Thank you! We\'ll take a look shortly!'
        });
      }, function (reason) {
        _this2.setState({
          error: reason.message
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$fields = _props.fields,
          nameInputProps = _props$fields.name,
          emailInputProps = _props$fields.email,
          subjectInputProps = _props$fields.subject,
          commentsInputProps = _props$fields.comments,
          urlInputProps = _props$fields.url,
          artworkUrlInputProps = _props$fields.artworkUrl,
          SocialPortfolioUrlProps = _props$fields.SocialPortfolioUrl,
          publishGameUrlProps = _props$fields.publishGameUrl,
          checkBoxInputProps = _props$fields.checkBoxPc,
          checkBoxSmartPhoneInputProps = _props$fields.checkBoxSmartPhone,
          checkBoxPlayStation = _props$fields.checkBoxPlayStation,
          checkBoxXboxInputProps = _props$fields.checkBoxXbox,
          checkBoxNitendoInputProps = _props$fields.checkBoxNitendo,
          checkBoxMacInputProps = _props$fields.checkBoxMac,
          checkBoxVrInputProps = _props$fields.checkBoxVr,
          checkBoxOtherInputProps = _props$fields.checkBoxOther,
          checkBoxPublisherInputProps = _props$fields.checkBoxPublisher,
          selectInputProps = _props$fields.select,
          teamSizeInputProps = _props$fields.teamSize,
          releaseDateInputProps = _props$fields.releaseDate,
          studioInputProps = _props$fields.studio,
          titleInputProps = _props$fields.title,
          checkBox_InputProps = _props$fields.checkBoxFunding,
          handleSubmit = _props.handleSubmit,
          submitting = _props.submitting,
          title = _props.title,
          description = _props.description,
          tag = _props.tag,
          childReference = _props.childReference;
      //console.log(this.props);

      return _react2.default.createElement(_IndieProgramPopup2.default, {
        icon: '/quixel_logo.png',
        nameInputProps: nameInputProps,
        emailInputProps: emailInputProps,
        urlInputProps: urlInputProps,
        artworkUrlProps: artworkUrlInputProps,
        publishGameUrlProps: publishGameUrlProps,
        SocialPortfolioUrlProps: SocialPortfolioUrlProps,
        subjectInputProps: subjectInputProps,
        commentsInputProps: commentsInputProps,
        checkBoxInputProps: checkBoxInputProps,
        checkBoxSmartPhoneInputProps: checkBoxSmartPhoneInputProps,
        checkBoxPlayStation: checkBoxPlayStation,
        checkBoxXboxInputProps: checkBoxXboxInputProps,
        checkBoxNitendoInputProps: checkBoxNitendoInputProps,
        checkBoxMacInputProps: checkBoxMacInputProps,
        checkBoxVrInputProps: checkBoxVrInputProps,
        checkBoxOtherInputProps: checkBoxOtherInputProps,
        checkBoxPublisherInputProps: checkBoxPublisherInputProps,
        selectInputProps: selectInputProps,
        teamSizeInputProps: teamSizeInputProps,
        releaseDateInputProps: releaseDateInputProps,
        studioInputProps: studioInputProps,
        titleInputProps: titleInputProps,
        checkBoxFunding: checkBox_InputProps,
        error: this.state.error,
        message: this.state.message,
        submitting: submitting,
        onSubmit: handleSubmit(this.onSubmitClick),
        title: title,
        description: description,
        tag: tag,
        onChildRef: childReference
      });
    }
  }]);
  return IndieProgramContainer;
}(_react2.default.Component)) || _class) || _class);
exports.default = IndieProgramContainer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/IndieProgramContainer/IndieProgramContainer.jsx
// module id = 2817
// module chunks = 0